<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" bottom app>
      <v-list nav>
        <v-list-item-group active-class="text--lighten-5 ">
          <v-list-item to="/">
            <v-list-item-title class="text-center">О клубе</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <!-- <v-list-item to="/forKids">
            <v-list-item-title class="text-center">Детям</v-list-item-title>
          </v-list-item>
          <v-list-item to="/forParents">
            <v-list-item-title class="text-center">Родителям</v-list-item-title>
          </v-list-item>
          <v-list-item to="/forSpecialist">
            <v-list-item-title class="text-center"
              >Программистам и <br />
              дизайнерам</v-list-item-title
            >
          </v-list-item> -->
         

          <v-list-item to="/signUp">
            <v-list-item-title class="text-center"
              ><b>ЗАПИСЬ</b></v-list-item-title
            >
          </v-list-item>

          <v-list-item to="/contacts">
            <v-list-item-title class="text-center">Контакты</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar class="elevation-0" color="main" app>
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        color="white"
      ></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <router-link to="/">
        <v-img max-width="260" src="./assets/images/logo.png"></v-img
      ></router-link>
      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({ drawer: null }),
  computed: {
    ...mapGetters(["IS_MOBILE", "IS_DESKTOP"]),
  },
  methods: {
    ...mapActions(["SET_MOBILE", "SET_DESKTOP"]),
  },
  mounted() {
    let vm = this;
    window.addEventListener(`resize`, function () {
      if (window.innerWidth > 767) {
        vm.SET_DESKTOP();
      } else {
        vm.SET_MOBILE();
      }
    });
    if (window.innerWidth > 767) {
      vm.SET_DESKTOP();
    } else {
      vm.SET_MOBILE();
    }
  },
};
</script>

<style lang="scss" scoped>
</style>

